import { render, staticRenderFns } from "./accountCancellationNotice.vue?vue&type=template&id=7b4ff294&scoped=true&"
import script from "./accountCancellationNotice.vue?vue&type=script&lang=js&"
export * from "./accountCancellationNotice.vue?vue&type=script&lang=js&"
import style0 from "./accountCancellationNotice.vue?vue&type=style&index=0&id=7b4ff294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ff294",
  null
  
)

export default component.exports